<template>
    <div>
        <div
            class="toast w-100 language-toast hidden mb-3"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
        >
            <div class="toast-body bg-white p-20">
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <p id="locale_text"></p>
                <p class="no-margin">
                    <button class="btn btn-light" id="locale_btn_yes"></button>
                    <button class="btn btn-light" id="locale_btn_no" data-dismiss="toast"></button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { globalLogger } from '../../../../helper/global-logger';
import { satGlobals } from '../../../../sat/helper/sat-globals';
import { isCookieSet } from '../../../../helper/cookie';
import 'bootstrap/js/dist/toast';

var setLocaleSuggestCookie = function (cookieDomain) {
    // 1 year
    var maxAge = 31557600;

    if (cookieDomain) {
        document.cookie = 'qg_locale_suggest=true; max-age=' + maxAge + '; path=/;domain=' + cookieDomain;
    } else {
        document.cookie = 'qg_locale_suggest=true; max-age=' + maxAge + '; path=/;';
    }
};

var init = function () {
    if (global.MODULE_LOADED_LOCALE_SWITCH) {
        globalLogger.log('double import locale switch');

        return;
    }

    global.MODULE_LOADED_LOCALE_SWITCH = true;

    let cookieDomain = satGlobals.getCookieDomain();

    var browserLocale = getBrowserLocale();

    $.each(satGlobals.getLocalePages(), function (key, value) {
        if (value.locale === browserLocale && !isCookieSet('qg_locale_suggest')) {
            showLocaleSuggest(value);
        }
    });

    setLocaleSuggestCookie(cookieDomain);
};

var showLocaleSuggest = function (config) {
    if (config.locale === satGlobals.getLocale()) {
        return;
    }

    var width = getBrowserWidth();

    if (width <= 450) {
        return;
    }

    globalLogger.log('localesuggest shown');

    $('.language-toast').removeClass('hidden');
    $('.language-toast').toast('show');
    $('#locale_btn_yes').html(config.btn_yes);
    $('#locale_btn_no').html(config.btn_no);
    $('#locale_text').html(config.message);

    $('#locale_btn_yes').click(function () {
        globalLogger.log('localesuggest switched');

        window.location = config.url;
    });
};

var getBrowserLocale = function () {
    var userLang = navigator.language || navigator.userLanguage;

    return userLang.slice(0, userLang.indexOf('-'));
};

var getBrowserWidth = function () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 1000;
};

export default {
    name: 'Localeselect',
    mounted() {
        init();
    },
    methods: {},
    data() {
        return {};
    },
};
</script>
